import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Navigator from '../components/Navigator'

import '../styles/IElement.css'

class InteractiveElement extends Component {
  _renderHitpoints () {
    const { hitpoints } = this.props.data

    if (hitpoints) {
      return hitpoints.map((hitpoint) => {
        const {
          width,
          height,
          top,
          left,
          targetType,
          targetId
        } = hitpoint

        const key = `${targetType}-${targetId}`

        return (
          <Navigator
            key={key}
            history={this.props.history}
            type={targetType}
            id={targetId}
            style={{position: 'absolute', width, height, top, left}} />
        )
      })
    }
  }

  render () {
    const {
      backgroundImage
    } = this.props.data

    return (
      <div className='IElement' style={{ position: 'relative', width: '100%', height: '100%' }}>
        <img src={backgroundImage} style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: 'auto' }} alt='Interactive Element' />
        {this._renderHitpoints()}
      </div>
    )
  }
}

InteractiveElement.propTypes = {
  data: PropTypes.object,
  history: PropTypes.object
}

export default InteractiveElement



// WEBPACK FOOTER //
// ./src/components/InteractiveElement.js